// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.field-box {
  display: flex;
  flex-wrap: wrap;
}

.submit-btn {
  margin-left: 23px;
}

.TopBox-Add-iser-2 {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 30px;
}

.add-user-inside {
  width: 100%;
}

.image-section-box {
  border: 1px solid #cccccc;
  border-radius: 7px;
  padding: 9px;
}

.auto-resize-textarea-10 {
  min-height: 50px;
  max-height: 200px;
  height: 50px !important;
  overflow-y: scroll;
  width: 195px;
  resize: none;
  display: block;
  padding: 4px 8px;
  border-radius: 8px;
  border: 1px solid #c4c4c4;
}

.error-msg {
  font-size: 10px;
}

.ql-toolbar.ql-snow {
  border-radius: 5px 5px 0 0;
}

.ql-toolbar.ql-snow+.ql-container.ql-snow {
  border-radius: 0 0 5px 5px;
  height: 80px;
}

.description-box-area {
  margin-top: 30px !important;
}

.description-image-container {
  display: flex;
  align-items: flex-end;
  gap: 20px;
  margin-top: 25px;
  flex-wrap: wrap;
}

.image-inside-2 {
  max-width: 283px;
  width: 100%;
  height: 75px;
  margin-top: 3px;
  object-fit: cover;
}


.image-input-class-22[type="file"] {
  height: auto;
  overflow: hidden;
  width: 100%;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 1;
  opacity: 0;
}

.image-input-class-22[type="file"]+.attach-icon {
  background: #fff;
  color: #000;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  font-family: 'Rubik', sans-serif;
  font-size: inherit;
  font-weight: 500;
  outline: none;
  position: relative;
  transition: all 0.3s;
  vertical-align: middle;
  width: 239px;
  text-align: left;
  height: 50px;
  display: flex !important;
  align-items: center;
  gap: 2px;
  padding-left: 0;
}

/* input[type="file"]+.attach-icon:hover {
    background-color: darken(#5569ff, 10%);
} */

.new-user-class {
  width: 46%;
}

.label-area-10 {
  margin-left: 10px;
}

.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.switch input { 
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: .4s;
}

input:checked + .slider {
  background-color: #2196F3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}`, "",{"version":3,"sources":["webpack://./src/content/applications/Quiz/addQuiz.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;;AAGA;EACE,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,MAAM;EACN,SAAS;EACT,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;;GAEG;;AAEH;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;EAEtB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EAEvB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EAGE,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".field-box {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.submit-btn {\n  margin-left: 23px;\n}\n\n.TopBox-Add-iser-2 {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  gap: 30px;\n}\n\n.add-user-inside {\n  width: 100%;\n}\n\n.image-section-box {\n  border: 1px solid #cccccc;\n  border-radius: 7px;\n  padding: 9px;\n}\n\n.auto-resize-textarea-10 {\n  min-height: 50px;\n  max-height: 200px;\n  height: 50px !important;\n  overflow-y: scroll;\n  width: 195px;\n  resize: none;\n  display: block;\n  padding: 4px 8px;\n  border-radius: 8px;\n  border: 1px solid #c4c4c4;\n}\n\n.error-msg {\n  font-size: 10px;\n}\n\n.ql-toolbar.ql-snow {\n  border-radius: 5px 5px 0 0;\n}\n\n.ql-toolbar.ql-snow+.ql-container.ql-snow {\n  border-radius: 0 0 5px 5px;\n  height: 80px;\n}\n\n.description-box-area {\n  margin-top: 30px !important;\n}\n\n.description-image-container {\n  display: flex;\n  align-items: flex-end;\n  gap: 20px;\n  margin-top: 25px;\n  flex-wrap: wrap;\n}\n\n.image-inside-2 {\n  max-width: 283px;\n  width: 100%;\n  height: 75px;\n  margin-top: 3px;\n  object-fit: cover;\n}\n\n\n.image-input-class-22[type=\"file\"] {\n  height: auto;\n  overflow: hidden;\n  width: 100%;\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  opacity: 0;\n}\n\n.image-input-class-22[type=\"file\"]+.attach-icon {\n  background: #fff;\n  color: #000;\n  border: none;\n  border-radius: 10px;\n  cursor: pointer;\n  font-family: 'Rubik', sans-serif;\n  font-size: inherit;\n  font-weight: 500;\n  outline: none;\n  position: relative;\n  transition: all 0.3s;\n  vertical-align: middle;\n  width: 239px;\n  text-align: left;\n  height: 50px;\n  display: flex !important;\n  align-items: center;\n  gap: 2px;\n  padding-left: 0;\n}\n\n/* input[type=\"file\"]+.attach-icon:hover {\n    background-color: darken(#5569ff, 10%);\n} */\n\n.new-user-class {\n  width: 46%;\n}\n\n.label-area-10 {\n  margin-left: 10px;\n}\n\n.switch {\n  position: relative;\n  display: inline-block;\n  width: 60px;\n  height: 34px;\n}\n\n.switch input { \n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #ccc;\n  -webkit-transition: .4s;\n  transition: .4s;\n}\n\n.slider:before {\n  position: absolute;\n  content: \"\";\n  height: 26px;\n  width: 26px;\n  left: 4px;\n  bottom: 4px;\n  background-color: white;\n  -webkit-transition: .4s;\n  transition: .4s;\n}\n\ninput:checked + .slider {\n  background-color: #2196F3;\n}\n\ninput:focus + .slider {\n  box-shadow: 0 0 1px #2196F3;\n}\n\ninput:checked + .slider:before {\n  -webkit-transform: translateX(26px);\n  -ms-transform: translateX(26px);\n  transform: translateX(26px);\n}\n\n/* Rounded sliders */\n.slider.round {\n  border-radius: 34px;\n}\n\n.slider.round:before {\n  border-radius: 50%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
